import React from 'react';
import classnames from 'classnames';

export default function Tertiary({ children, disabled, ...rest }) {
  return (
    <a
      className={classnames(
        'button button--tertiary',
        disabled && 'button--disabled',
      )}
      disabled={disabled}
      {...rest}
    >
      {children}
    </a>
  );
}